// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-pdf-wrapper .react-select-multi__menu {
  width: 100%;
  max-width: unset;
  min-width: unset;
}
.export-pdf-wrapper .react-select-multi__multi-value {
  display: none;
}
.export-pdf-wrapper .select-submissions-title {
  font-size: 18px;
  font-weight: 600;
}
.export-pdf-wrapper .to-view-list-title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 90px;
}
.export-pdf-wrapper .form-item-mail {
  position: relative;
}
.export-pdf-wrapper .form-item-mail .mail-icon {
  position: absolute;
  top: 36px;
  left: 16px;
}
.export-pdf-wrapper .form-item-mail .form-control {
  padding: 12px 12px 12px 43px;
}
.export-pdf-wrapper .selected--forms {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 15px;
  margin-bottom: 5px;
}
.export-pdf-wrapper .selected--forms .selected--forms__list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  margin-right: 5px;
  gap: 0;
}
.export-pdf-wrapper .selected--forms .selected--forms__list__item p {
  width: fit-content;
}
.export-pdf-wrapper .selected--forms .selected--forms__list__item:hover {
  color: #7f56d9;
}
.export-pdf-wrapper .selected--forms .selected--forms__list__item svg {
  cursor: pointer;
  margin-left: 10px;
  flex-shrink: 0;
}
.export-pdf-wrapper .selected--forms .selected--forms__list__item svg:hover {
  opacity: 0.7;
}
.export-pdf-wrapper .table-responsive .thead .tr .th {
  padding: 10px 24px;
  text-align: center;
  vertical-align: middle;
}
.export-pdf-wrapper .table-responsive .thead .tr .th:nth-child(1) {
  width: 90px;
  padding: 10px 30px;
  padding-right: 0px;
  text-align: left;
}
.export-pdf-wrapper .table-responsive .thead .tr .th:nth-child(2) {
  text-align: left;
}
.export-pdf-wrapper .table-responsive .thead .tr .th .select-all-label {
  margin-left: 12px;
  color: #98a2b3;
  font-weight: 400;
  font-size: 16px;
  vertical-align: bottom;
  line-height: 24px;
}
.export-pdf-wrapper .table-responsive .tbody .tr .td {
  padding: 10px 24px;
  text-align: center;
  font-weight: 400;
}
.export-pdf-wrapper .table-responsive .tbody .tr .td:nth-child(1) {
  padding: 10px 30px;
  padding-right: 0;
  padding-left: 10px;
  text-align: left;
}
.export-pdf-wrapper .table-responsive .tbody .tr .td:nth-child(1) .form-control-checkbox {
  left: 30px;
}
.export-pdf-wrapper .table-responsive .tbody .tr .td:nth-child(2) {
  text-align: left;
  font-weight: 500;
  color: #101828;
  max-width: 300px;
}
.export-pdf-wrapper .table-responsive .tbody .tr .td:nth-child(3) {
  width: fit-content;
}
.export-pdf-wrapper .report-builder-aside {
  height: calc(100vh - 80px);
  overflow-y: auto;
  position: fixed;
  right: 0;
}
.export-pdf-wrapper .generate-pdf-block {
  margin-bottom: 40px;
}
.export-pdf-wrapper .generate-pdf-block button {
  padding: 10px 15px;
}
.export-pdf-wrapper h2.title {
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/user/export-user-submissions/styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAKI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAHN;AAMI;EACE,4BAAA;AAJN;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,MAAA;AANN;AAQM;EACE,kBAAA;AANR;AASM;EACE,cAAA;AAPR;AASM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAPR;AAQQ;EACE,YAAA;AANV;AAeQ;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;AAbV;AAcU;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAZZ;AAeU;EACE,gBAAA;AAbZ;AAgBU;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAdZ;AAqBQ;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAnBV;AAqBU;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAnBZ;AAqBY;EACE,UAAA;AAnBd;AAuBU;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArBZ;AAwBU;EACE,kBAAA;AAtBZ;AA6BE;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AA3BJ;AA8BE;EACE,mBAAA;AA5BJ;AA8BI;EACE,kBAAA;AA5BN;AAgCE;EACE,2BAAA;AA9BJ","sourcesContent":[".export-pdf-wrapper {\n  .react-select-multi__menu {\n    width: 100%;\n    max-width: unset;\n    min-width: unset;\n  }\n\n  .react-select-multi__multi-value {\n    display: none;\n  }\n\n  .select-submissions-title {\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .to-view-list-title {\n    font-size: 18px;\n    font-weight: 600;\n    margin-top: 90px;\n  }\n\n  .form-item-mail {\n    position: relative;\n    .mail-icon {\n      position: absolute;\n      top: 36px;\n      left: 16px;\n    }\n\n    .form-control {\n      padding: 12px 12px 12px 43px;\n    }\n  }\n\n  .selected--forms {\n    max-height: 200px;\n    overflow-y: auto;\n    margin-top: 15px;\n    margin-bottom: 5px;\n\n    .selected--forms__list__item {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin: 10px 0;\n      margin-right: 5px;\n      gap: 0;\n\n      p {\n        width: fit-content;\n      }\n\n      &:hover {\n        color: #7f56d9;\n      }\n      svg {\n        cursor: pointer;\n        margin-left: 10px;\n        flex-shrink: 0;\n        &:hover {\n          opacity: 0.7;\n        }\n      }\n    }\n  }\n\n  .table-responsive {\n    .thead {\n      .tr {\n        .th {\n          padding: 10px 24px;\n          text-align: center;\n          vertical-align: middle;\n          &:nth-child(1) {\n            width: 90px;\n            padding: 10px 30px;\n            padding-right: 0px;\n            text-align: left;\n          }\n\n          &:nth-child(2) {\n            text-align: left;\n          }\n\n          .select-all-label {\n            margin-left: 12px;\n            color: #98a2b3;\n            font-weight: 400;\n            font-size: 16px;\n            vertical-align: bottom;\n            line-height: 24px;\n          }\n        }\n      }\n    }\n    .tbody {\n      .tr {\n        .td {\n          padding: 10px 24px;\n          text-align: center;\n          font-weight: 400;\n\n          &:nth-child(1) {\n            padding: 10px 30px;\n            padding-right: 0;\n            padding-left: 10px;\n            text-align: left;\n\n            .form-control-checkbox {\n              left: 30px;\n            }\n          }\n\n          &:nth-child(2) {\n            text-align: left;\n            font-weight: 500;\n            color: #101828;\n            max-width: 300px;\n          }\n\n          &:nth-child(3) {\n            width: fit-content;\n          }\n        }\n      }\n    }\n  }\n\n  .report-builder-aside {\n    height: calc(100vh - 80px);\n    overflow-y: auto;\n    position: fixed;\n    right: 0;\n  }\n\n  .generate-pdf-block {\n    margin-bottom: 40px;\n\n    button {\n      padding: 10px 15px;\n    }\n  }\n\n  h2.title {\n    margin-bottom: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
